import { useEffect, useRef, useState } from 'react'

// material-ui
import { useTheme } from '@mui/material/styles'
import {
  Avatar,
  Box,
  ClickAwayListener,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Typography,
  useMediaQuery,Stack
} from '@mui/material'

// project imports
import Transitions from 'ui-component/extended/Transitions'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// assets
import TranslateTwoToneIcon from '@mui/icons-material/TranslateTwoTone'
import useConfig from 'hooks/useConfig'
import i18next from 'i18next'
import { getLanguages } from '../../../../store/slices/languageAction'
import { connect } from 'react-redux'
import { getLabelsName } from 'store/slices/labelAction'
// ==============================|| LOCALIZATION ||============================== //

const LocalizationSection = (props) => {
  const { borderRadius, locale, onChangeLocale } = useConfig()
  const { languages } = props.languages
  const {getLabelsName}=props
  const theme = useTheme()
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'))

  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)
  const [language, setLanguage] = useState(locale)

  const handleListItemClick = (event, lng) => {
    setOpen(false);
    const prevLang = localStorage.getItem('i18nextLng')
    localStorage.setItem('prevLangAdmin', prevLang)
    localStorage.setItem('i18nextLng', lng)
    setLanguage(lng)
     getLabelsName()
  
    onChangeLocale(lng)
    // window.location.reload(false)
    // i18next.changeLanguage(lng)
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  const prevOpen = useRef(open)
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }
    prevOpen.current = open
  }, [open])

  useEffect(() => {
    setLanguage(locale)
  }, [locale])

  useEffect(() => {
    props.getLanguages()
  }, [])

  let ActiveLan = languages?.filter((e) => e.flag === 1)
  let ActiveMap = languages?.filter((e) => e.language_code === language);
  return (
    <>
      <Box
        sx={{
          ml: 2,
          [theme.breakpoints.down('md')]: {
            ml: 1,
          },
        }}
      >
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            // border: '1px solid',
            width: "80px",
            padding: "10px",
            // borderColor:
            //   theme.palette.mode === 'dark'
            //     ? theme.palette.dark.main
            //     : theme.palette.primary.light,
            background:
              theme.palette.mode === 'dark'
                ? theme.palette.dark.main
                : theme.palette.primary.light,
            color: theme.palette.primary.dark,
        
            transition: 'all .2s ease-in-out',
            '&[aria-controls="menu-list-grow"],&:hover': {
              // borderColor: theme.palette.primary.main,
              background: theme.palette.primary.main,
              color: theme.palette.primary.light,
            },
            "&:hover": {
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.secondary.main
                  : theme.palette.secondary.dark,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.secondary.light
                  : theme.palette.secondary.light,
             
            },
          }}
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          color="inherit"
        >
             <img
            src={ActiveMap?.length>0  ? ActiveMap[0]?.image :"" }
            alt="map"
            width="35px"
            height="20px"
            style={{ paddingLeft: "7px" }}
          />
          {language !== 'en' && (
            <Typography
              variant="h5"
              sx={{ textTransform: 'uppercase' ,pl:1}}
              color="#000000"
            >
              {language}
            </Typography>
          )}
          {language === 'en' && (
           <Typography
           variant="h5"
           sx={{ textTransform: "uppercase", pl: 1 }}
           color="#000000"
         >
           EN
         </Typography>
          )}
            <ExpandMoreIcon style={{ color: "#000000" }} />
        </Avatar>
      </Box>

      <Popper
        placement={matchesXs ? 'bottom-start' : 'bottom'}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [matchesXs ? 0 : 0, 20],
              },
            },
          ],
        }}
  
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Transitions
              position={matchesXs ? 'top-left' : 'top'}
              in={open}
            
              {...TransitionProps}
            >
              <Paper elevation={16}>
                {open && (
                  <List
                    component="nav"
                    sx={{
                      width: '100%',
                      minWidth: 200,
                      maxWidth: 280,
                      background: '#EDEDED',

                      color: theme.palette.warning.yellow,
                      // bgcolor: theme.palette.background.paper,
                      borderRadius: `${borderRadius}px`,
                      [theme.breakpoints.down('md')]: {
                        maxWidth: 250,
                      },
                    }}
                  >
                    {ActiveLan.map((lang, i) => (
                      <ListItemButton
                        selected={language === lang.language_code}
                        onClick={(event) =>{handleListItemClick(event, lang.language_code)}
                         
                        }
                      >
                        <ListItemText
                   
                          primary={
                            <Grid container>
                                <Stack direction="row">
                                <img
                                  src={lang?.image}
                                  alt="map"
                                  width="35px"
                                  height="20px"
                                  style={{
                                    paddingLeft: "7px",
                                    paddingRight: "7px",
                                  }}
                                />
                              <Typography
                                color={
                                  language === lang.language_code
                                    ? '#f5d792'
                                    : 'textPrimary'
                                }
                              >
                                {lang.language_name}
                              </Typography>
                              </Stack>
                              {/* <Typography
                              variant="caption"
                              color={
                                language === "en" ? "#f5d792" : "textPrimary"
                              }
                              sx={{ ml: "8px" }}
                            >
                              (UK)
                            </Typography> */}
                            </Grid>
                          }
                        />
                      </ListItemButton>
                    ))}
                    {/* <ListItemButton
                      selected={language === "is"}
                      onClick={(event) => handleListItemClick(event, "is")}
                    >
                      <ListItemText
                        primary={
                          <Grid container>
                            <Typography
                              color={
                                language === "is" ? "#f5d792" : "textPrimary"
                              }
                            >
                              Icelandic
                            </Typography>
                            <Typography
                              variant="caption"
                              color={
                                language === "is" ? "#f5d792" : "textPrimary"
                              }
                              sx={{ ml: "8px" }}
                            >
                              (Is)
                            </Typography>
                          </Grid>
                        }
                      />
                    </ListItemButton> */}
                  </List>
                )}
              </Paper>
            </Transitions>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  )
}

const mapStateToProps = (state) => ({
  languages: state.language,
})

export default connect(mapStateToProps, { getLanguages,getLabelsName })(LocalizationSection)
